import AgedInventoryItem from './AgedInventoryItem';

function AgedInventoryItemList({ activeList }) {
    return (
        <div className="mt-6 mx-5">
            <div className="products-list">
                <div className="mt-3 border border-[#EAEAEA] rounded-lg">
                    <div className="flex bg-[#F5F5F5] font-semibold text-[#666666]">
                        <h2 className="w-[70%] max-[1280px]:w-[65%] max-[1080px]:w-[62%] px-[10px] py-2 text-[14px] leading-6 uppercase">Product</h2>
                        <h2 className="w-[15%] max-[1280px]:w-[17.5%] max-[1080px]:w-[19%] px-[10px] py-2 text-[14px] leading-6 uppercase">sku code</h2>
                        <h2 className="w-[15%] max-[1280px]:w-[17.5%] max-[1080px]:w-[19%] px-[10px] py-2 text-[14px] leading-6">Available Stock</h2>
                    </div>

                    {activeList.map(item => {
                        return (
                            <AgedInventoryItem 
                                key={item.productId} 
                                item={item} 
                            />
                        )
                    })}
                </div>
            </div>
        </div>
    )
}

export default AgedInventoryItemList;
